import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, SexOptions, TermFilter } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/personnel-report/PersonnelReportAction";
import { usePersonnelReportUIContext } from "../PersonnelReportUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, personnelTypeId, name, surname, sex, date, other } = values;
  const newQueryParams = { ...queryParams };
  const filter = { personnelTypeId, name, surname, sex, date, other };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function PersonnelReportFilter() {
  // Personnel Report UI Context
  const personnelReportUIContext = usePersonnelReportUIContext();
  const personnelReportUIProps = useMemo(() => {
    return {
      setQueryParams: personnelReportUIContext.setQueryParams,
      queryParams: personnelReportUIContext.queryParams,
    };
  }, [personnelReportUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, personnelTypes } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      personnelTypes: state.personnelReport.personnelTypes
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPersonnelTypes());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(personnelReportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, personnelReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      personnelReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const personnelTypesOptions = FilterOptions.concat(personnelTypes);
  const sexOptions = FilterOptions.concat(SexOptions);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        name: "",
        surname: "",
        other: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">            
            <div className="col-lg-2">
              <CustomSelect
                options={personnelTypesOptions}
                value={values.personnelTypeId}
                placeholder="Personel Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("personnelTypeId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Personel Türü</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="date"
                placeholder="Tarih"
                onBlur={handleBlur}
                value={values.date}
                onChange={(e) => {
                  setFieldValue("date", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tarih</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="other"
                placeholder="Diğer"
                onBlur={handleBlur}
                value={values.other}
                onChange={(e) => {
                  setFieldValue("other", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Diğer</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}